var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreviewOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8602 10.5714C21.6636 10.3025 16.9808 3.98828 10.9999 3.98828C5.019 3.98828 0.3359 10.3025 0.1396 10.5711C-0.0465 10.8262 -0.0465 11.1721 0.1396 11.4272C0.3359 11.696 5.019 18.0103 10.9999 18.0103C16.9808 18.0103 21.6636 11.696 21.8602 11.4274C22.0466 11.1724 22.0466 10.8262 21.8602 10.5714ZM10.9999 16.5597C6.5943 16.5597 2.7787 12.3688 1.6491 10.9988C2.7772 9.62751 6.5849 5.43882 10.9999 5.43882C15.4052 5.43882 19.2206 9.62897 20.3506 10.9998C19.2226 12.371 15.4149 16.5597 10.9999 16.5597Z",
    fill: "#323232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 6.64844C8.6006 6.64844 6.6484 8.60064 6.6484 11.0001C6.6484 13.3996 8.6006 15.3518 11.0001 15.3518C13.3996 15.3518 15.3518 13.3996 15.3518 11.0001C15.3518 8.60064 13.3996 6.64844 11.0001 6.64844ZM11.0001 13.9012C9.4004 13.9012 8.099 12.5998 8.099 11.0001C8.099 9.40042 9.4004 8.09902 11.0001 8.09902C12.5998 8.09902 13.9012 9.40042 13.9012 11.0001C13.9012 12.5998 12.5998 13.9012 11.0001 13.9012Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewOutline);
export default __webpack_public_path__ + "static/media/previewOutline.0cb0be804e89419b5f9a92df26b27578.svg";
export { ForwardRef as ReactComponent };